import { render } from "./AppLoader.vue?vue&type=template&id=379344c4"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=379344c4&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__